import { Component, OnInit, HostListener } from '@angular/core';
import * as jQ from 'jquery';

@Component({
  selector: 'app-kids-classes',
  templateUrl: './kids-classes.component.html',
  styleUrls: ['./kids-classes.component.css']
})
export class KidsClassesComponent implements OnInit {
	
	@HostListener('document:scroll', ['$event']) onScroll(e) {
		let scrollPosition = window.scrollY;
		let height = window.innerHeight;
		let opacity = ((height-scrollPosition)/height);
		jQ('.bg-img').css('opacity', opacity);
	}

  constructor() { }

  ngOnInit() {
  }

}
